import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

const getHasFocusedValueStylesAsClassName = (leftAligned: boolean): string => {
  return cx('font-normal', 'text-xs', 'leading-10/7', {
    'top-0 translate-y-0': true,
    'top-[1px]': !leftAligned,
  });
};

export const getFormFieldLabelStylesAsClassName = (
  hasFocusedValue: boolean,
  isDisabled: boolean,
  leftAligned = false
): string => {
  return twMerge(
    cx(
      'text-primary-main',
      'text-md',
      'leading-10/7',
      'absolute',
      'top-[11px]',
      'left-4',
      'transition-[color, font-size, top, transform]',
      'duration-200',
      'ease-in-out',
      'pointer-events-none'
    ),
    cx({ 'right-4': !leftAligned }),
    cx({ 'text-gray-main': isDisabled }),
    cx({ [getHasFocusedValueStylesAsClassName(leftAligned)]: hasFocusedValue })
  );
};
